// TODO: delete this file

import React from "react"
import PropTypes from "prop-types"

// components
import { ReactGridLayoutTypeSelect } from "app/static/frontend/selects/containers/EnumSelect"

export const DashboardDebug = (props) => {
    // https://github.com/STRML/react-grid-layout/blob/master/test/test-hook.jsx
    const renderCoorinates = () =>
        props.layout.map(item => (
            <div
                className="layoutItem"
                key={item.i}
            >
                <b>{item.i}</b>: [{item.x}, {item.y}, {item.w}, {item.h}]
            </div>
        ))

    return (
        <div className={`${props.className} react-grid-layout debug`}>
            {
                props.layout && (
                    <div className="react-grid-layout coordinates">
                        Displayed as <code>[x, y, w, h]</code>:
                        <div className="columns">
                            {renderCoorinates()}
                        </div>
                    </div>
                )
            }
            {
                props.editing && (
                    <div className="react-grid-layout options">
                        <ReactGridLayoutTypeSelect
                            clearable={false}
                            onChange={(option) => {
                                // if we want to update the weight of the dashboard grid,
                                // we set the compactType to the result of the select value
                                props.setDashboardsValues({
                                    id: props.id,
                                    values: {
                                        compactType: option.value,
                                    }
                                })
                            }}
                            value={props.compactType}
                        />
                    </div>
                )
            }
        </div>
    )
}

DashboardDebug.propTypes = {
    // from styled()
    className: PropTypes.string,

    // defaultProps
    id: PropTypes.string,

    // action creators
    setDashboardsValues: PropTypes.func,

    // store
    compactType: PropTypes.number,
    editing: PropTypes.bool,
    layout: PropTypes.array,
}

export default DashboardDebug
